import {
  BagFeaturedUpsell,
  BagUpsellProductOption,
  BagUpsellRail,
  BagUpsellRailSkeleton,
} from './components';

export const BagUpsell = {
  Rail: BagUpsellRail,
  RailSkeleton: BagUpsellRailSkeleton,
  ProductOption: BagUpsellProductOption,
  Featured: BagFeaturedUpsell,
};

export { useBagFeaturedUpsellContent, useInitBagFeaturedUpsellMachine } from './components';
